import * as VisualizationTypes from 'reporting-visualizations/constants/visualizationTypes';
import { SlicedStyle } from 'reporting-visualizations/visualizations/sliced/slicedRecords';
import { Style as TableStyle } from 'reporting-visualizations/visualizations/table/tableRecords';
import { Style as XYStyle } from 'reporting-visualizations/visualizations/xy/xyRecords';
const StyleRecordsByType = {
  [VisualizationTypes.TABLE]: TableStyle,
  [VisualizationTypes.SLICED]: SlicedStyle,
  [VisualizationTypes.XY]: XYStyle
};
export const sanitizeVizForMobile = (isMobile, viz, mobileReportingOptions = {}) => {
  const {
    enableDeepLinking
  } = mobileReportingOptions;
  if (StyleRecordsByType[viz.get('type')]) {
    viz = viz.get('style') ? viz.setIn(['style', 'isMobile'], isMobile) : viz.set('style', StyleRecordsByType[viz.get('type')]({
      isMobile
    }));
    if (!isMobile) {
      return viz;
    }
  }
  if (viz.get('type') === VisualizationTypes.TABLE && !enableDeepLinking) {
    return viz.update('columns', columns => columns.map(column => column.delete('linkField')));
  }
  return viz;
};